import { IconProps } from "../../../types/style";

const BigCarIcon = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.6667 4.39341V15.4734C18.6667 16.8334 17.5601 17.9401 16.2001 17.9401H4.00008C3.26675 17.9401 2.66675 17.3401 2.66675 16.6067V8.08675C2.66675 5.36675 4.86675 3.16675 7.58675 3.16675H17.4267C18.1201 3.16675 18.6667 3.71341 18.6667 4.39341Z"
          fill={color}
        />
        <path
          d="M28.6667 21.1667C29.0401 21.1667 29.3334 21.4601 29.3334 21.8334V23.1667C29.3334 25.3801 27.5467 27.1667 25.3334 27.1667C25.3334 24.9667 23.5334 23.1667 21.3334 23.1667C19.1334 23.1667 17.3334 24.9667 17.3334 27.1667H14.6667C14.6667 24.9667 12.8667 23.1667 10.6667 23.1667C8.46675 23.1667 6.66675 24.9667 6.66675 27.1667C4.45341 27.1667 2.66675 25.3801 2.66675 23.1667V20.5001C2.66675 19.7667 3.26675 19.1667 4.00008 19.1667H16.6667C18.5067 19.1667 20.0001 17.6734 20.0001 15.8334V8.50008C20.0001 7.76675 20.6001 7.16675 21.3334 7.16675H22.4534C23.4134 7.16675 24.2934 7.68675 24.7734 8.51342L25.6267 10.0067C25.7467 10.2201 25.5867 10.5001 25.3334 10.5001C23.4934 10.5001 22.0001 11.9934 22.0001 13.8334V17.8334C22.0001 19.6734 23.4934 21.1667 25.3334 21.1667H28.6667Z"
          fill={color}
        />
        <path
          d="M10.6667 29.8333C12.1394 29.8333 13.3333 28.6394 13.3333 27.1667C13.3333 25.6939 12.1394 24.5 10.6667 24.5C9.19391 24.5 8 25.6939 8 27.1667C8 28.6394 9.19391 29.8333 10.6667 29.8333Z"
          fill={color}
        />
        <path
          d="M21.3334 29.8333C22.8062 29.8333 24.0001 28.6394 24.0001 27.1667C24.0001 25.6939 22.8062 24.5 21.3334 24.5C19.8607 24.5 18.6667 25.6939 18.6667 27.1667C18.6667 28.6394 19.8607 29.8333 21.3334 29.8333Z"
          fill={color}
        />
        <path
          d="M29.3333 17.2067V19.1667H25.3333C24.6 19.1667 24 18.5667 24 17.8333V13.8333C24 13.1 24.6 12.5 25.3333 12.5H27.0533L28.9867 15.8867C29.2133 16.2867 29.3333 16.74 29.3333 17.2067Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default BigCarIcon;
